/* src/app/features/leilao/pesquisa/leilao-listagem/leilao-listagem.component.scss */
/*# sourceMappingURL=leilao-listagem.component.css.map */
